import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateCss } from '../pdf-document-template-css';

@Component({
  selector: 'app-pdf-template-csses',
  templateUrl: './pdf-template-csses.component.html',
  styleUrls: ['./pdf-template-csses.component.css']
})
export class PdfTemplateCssesComponent implements OnInit {

  csses: PdfDocumentTemplateCss[] = [];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.httpService.getAllPdfDocumentTemplateCsses().subscribe(res => {
      this.csses = res;
    });
  }

}
